const beneficios = [
  { icon: 'ri-user-heart-line', text: 'Acompanamiento humano segun disponibilidad' },
  { icon: 'ri-mental-health-line', text: 'Orientacion emocional para ti o tu familia' },
  { icon: 'ri-calendar-check-line', text: 'Tres sesiones incluidas dentro de tu membresia' },
];

export default function AcompanamientoSection() {
  return (
    <section id="acompanamiento" className="py-20 md:py-32 overflow-hidden" style={{ background: '#0A0A0A' }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-16 lg:gap-20 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden" style={{ paddingBottom: '110%' }}>
              <img
                src="https://storage.readdy-site.link/project_files/0e36dce5-70eb-43ef-8fa1-9c06248cd1a7/a93c2413-a4aa-4bb0-8c35-a31e5864c7db_Diseo-sin-ttulo-23.pngv=634b3fa464dac7937101a36b3a30e651"
                alt="Acompanamiento tanatologico Coverly"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(10,10,10,0.6) 0%, transparent 50%)' }} />
              <div
                className="absolute bottom-5 left-5 right-5 px-5 py-4 rounded-2xl backdrop-blur-md"
                style={{ background: 'rgba(83,74,183,0.85)', border: '1px solid rgba(175,169,236,0.3)' }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(255,255,255,0.15)' }}>
                    <i className="ri-award-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">3 sesiones incluidas</p>
                    <p className="text-white/65 text-xs">Con tanatologo certificado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="inline-flex items-center gap-2 bg-white/8 text-[#AFA9EC] text-xs font-semibold px-4 py-2 rounded-full mb-6 tracking-wide uppercase border border-white/10">
              <i className="ri-heart-pulse-line"></i>
              Acompanamiento emocional
            </div>

            <h2 className="font-title text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-6">
              Tambien acompanamos el{' '}
              <span style={{ color: '#AFA9EC' }}>proceso emocional</span>
            </h2>

            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8 font-light">
              Tu membresia incluye 3 sesiones con un tanatologo, segun disponibilidad en tu estado o ciudad, para orientar a la familia durante el proceso.
            </p>

            <div className="space-y-4 mb-10">
              {beneficios.map((b) => (
                <div
                  key={b.text}
                  className="flex items-center gap-4 p-4 rounded-2xl"
                  style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(175,169,236,0.12)' }}
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(83,74,183,0.3)' }}>
                    <i className={`${b.icon} text-[#AFA9EC] text-lg`}></i>
                  </div>
                  <p className="text-white/80 text-sm font-medium">{b.text}</p>
                </div>
              ))}
            </div>

            <div
              className="p-6 rounded-2xl"
              style={{ background: 'linear-gradient(135deg, rgba(83,74,183,0.2) 0%, rgba(60,52,137,0.15) 100%)', border: '1px solid rgba(175,169,236,0.2)' }}
            >
              <i className="ri-double-quotes-l text-[#AFA9EC] text-2xl mb-3 block"></i>
              <p className="text-white/90 text-lg md:text-xl leading-relaxed font-light italic">
                Porque organizar a tu familia tambien significa dejar acompanamiento claro para el momento dificil.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
